<template>
    <div class="main-stats mb-4">
        <div class="row">
            <!-- Card Hoje -->
            <div class="col-xl-3 col-md-6 mb-4">
                <div class="metric-card today-card">
                    <div class="metric-header">
                        <div class="metric-icon">
                            <i class="fas fa-calendar-day"></i>
                        </div>
                        <div class="metric-period">Hoje</div>
                    </div>
                    <div class="metric-content">
                        <div
                            class="metric-value"
                            v-if="!loadingStats"
                        >
                            {{ formatNumber(statsData.today ? statsData.today.total : 0) }}
                        </div>
                        <div
                            class="metric-loading"
                            v-else
                        >
                            <i class="fas fa-spinner fa-spin"></i>
                        </div>
                        <div class="metric-label">Total de Requisições</div>

                        <div
                            class="metric-details"
                            v-if="!loadingStats"
                        >
                            <div class="detail-row">
                                <span class="detail-label">
                                    <i class="fas fa-check-circle text-success"></i>
                                    Sucessos:
                                </span>
                                <span class="detail-value text-success">
                                    {{ formatNumber(statsData.today ? statsData.today.success : 0) }}
                                </span>
                            </div>
                            <div class="detail-row">
                                <span class="detail-label">
                                    <i class="fas fa-times-circle text-danger"></i>
                                    Erros:
                                </span>
                                <span class="detail-value text-danger">
                                    {{ formatNumber(statsData.today ? statsData.today.errors : 0) }}
                                </span>
                            </div>
                        </div>

                        <div
                            class="metric-footer"
                            v-if="!loadingStats"
                        >
                            <div class="success-rate">
                                <span class="rate-label">Taxa de Sucesso:</span>
                                <span class="rate-value">
                                    {{ formatPercentage(statsData.today ? statsData.today.success_rate : 0) }}%
                                </span>
                            </div>
                            <div class="progress progress-animated">
                                <div
                                    class="progress-bar bg-gradient-success"
                                    :style="`width: ${statsData.today ? statsData.today.success_rate : 0}%`"
                                ></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Card Esta Semana -->
            <div class="col-xl-3 col-md-6 mb-4">
                <div class="metric-card week-card">
                    <div class="metric-header">
                        <div class="metric-icon">
                            <i class="fas fa-calendar-week"></i>
                        </div>
                        <div class="metric-period">Esta Semana</div>
                    </div>
                    <div class="metric-content">
                        <div
                            class="metric-value"
                            v-if="!loadingStats"
                        >
                            {{ formatNumber(statsData.week ? statsData.week.total : 0) }}
                        </div>
                        <div
                            class="metric-loading"
                            v-else
                        >
                            <i class="fas fa-spinner fa-spin"></i>
                        </div>
                        <div class="metric-label">Total de Requisições</div>

                        <div
                            class="metric-details"
                            v-if="!loadingStats"
                        >
                            <div class="detail-row">
                                <span class="detail-label">
                                    <i class="fas fa-check-circle text-success"></i>
                                    Sucessos:
                                </span>
                                <span class="detail-value text-success">
                                    {{ formatNumber(statsData.week ? statsData.week.success : 0) }}
                                </span>
                            </div>
                            <div class="detail-row">
                                <span class="detail-label">
                                    <i class="fas fa-stopwatch text-info"></i>
                                    Tempo Médio:
                                </span>
                                <span class="detail-value text-info">
                                    {{ formatExecutionTime(statsData.week ? statsData.week.avg_execution_time : 0) }}
                                </span>
                            </div>
                        </div>

                        <div
                            class="metric-footer"
                            v-if="!loadingStats"
                        >
                            <div class="success-rate">
                                <span class="rate-label">Taxa de Sucesso:</span>
                                <span class="rate-value">
                                    {{ formatPercentage(statsData.week ? statsData.week.success_rate : 0) }}%
                                </span>
                            </div>
                            <div class="progress progress-animated">
                                <div
                                    class="progress-bar bg-gradient-primary"
                                    :style="`width: ${statsData.week ? statsData.week.success_rate : 0}%`"
                                ></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Card Este Mês -->
            <div class="col-xl-3 col-md-6 mb-4">
                <div class="metric-card month-card">
                    <div class="metric-header">
                        <div class="metric-icon">
                            <i class="fas fa-calendar-alt"></i>
                        </div>
                        <div class="metric-period">Este Mês</div>
                    </div>
                    <div class="metric-content">
                        <div
                            class="metric-value"
                            v-if="!loadingStats"
                        >
                            {{ formatNumber(statsData.month ? statsData.month.total : 0) }}
                        </div>
                        <div
                            class="metric-loading"
                            v-else
                        >
                            <i class="fas fa-spinner fa-spin"></i>
                        </div>
                        <div class="metric-label">Total de Requisições</div>

                        <div
                            class="metric-details"
                            v-if="!loadingStats"
                        >
                            <div class="detail-row">
                                <span class="detail-label">
                                    <i class="fas fa-check-circle text-success"></i>
                                    Sucessos:
                                </span>
                                <span class="detail-value text-success">
                                    {{ formatNumber(statsData.month ? statsData.month.success : 0) }}
                                </span>
                            </div>
                            <div class="detail-row">
                                <span class="detail-label">
                                    <i class="fas fa-times-circle text-danger"></i>
                                    Erros:
                                </span>
                                <span class="detail-value text-danger">
                                    {{ formatNumber(statsData.month ? statsData.month.errors : 0) }}
                                </span>
                            </div>
                        </div>

                        <div
                            class="metric-footer"
                            v-if="!loadingStats"
                        >
                            <div class="success-rate">
                                <span class="rate-label">Taxa de Sucesso:</span>
                                <span class="rate-value">
                                    {{ formatPercentage(statsData.month ? statsData.month.success_rate : 0) }}%
                                </span>
                            </div>
                            <div class="progress progress-animated">
                                <div
                                    class="progress-bar bg-gradient-warning"
                                    :style="`width: ${statsData.month ? statsData.month.success_rate : 0}%`"
                                ></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Card Performance -->
            <div class="col-xl-3 col-md-6 mb-4">
                <div class="metric-card performance-card">
                    <div class="metric-header">
                        <div class="metric-icon">
                            <i class="fas fa-tachometer-alt"></i>
                        </div>
                        <div class="metric-period">Performance</div>
                    </div>
                    <div class="metric-content">
                        <div
                            class="metric-value"
                            v-if="!loadingStats"
                        >
                            {{ formatExecutionTime(statsData.week ? statsData.week.avg_execution_time : 0) }}
                        </div>
                        <div
                            class="metric-loading"
                            v-else
                        >
                            <i class="fas fa-spinner fa-spin"></i>
                        </div>
                        <div class="metric-label">Tempo Médio Semanal</div>

                        <div
                            class="metric-details"
                            v-if="!loadingStats"
                        >
                            <div class="detail-row">
                                <span class="detail-label">
                                    <i class="fas fa-rocket text-success"></i>
                                    Rápidas:
                                </span>
                                <span class="detail-value text-success">
                                    {{
                                        formatNumber(statsData.performance ? statsData.performance.fast_requests_week : 0)
                                    }}
                                </span>
                            </div>
                            <div class="detail-row">
                                <span class="detail-label">
                                    <i class="fas fa-stopwatch text-danger"></i>
                                    Lentas:
                                </span>
                                <span class="detail-value text-danger">
                                    {{
                                        formatNumber(statsData.performance ? statsData.performance.slow_requests_week : 0)
                                    }}
                                </span>
                            </div>
                            <div
                                class="detail-row"
                                v-if="statsData.performance && statsData.performance.very_slow_requests_week"
                            >
                                <span class="detail-label">
                                    <i class="fas fa-exclamation-triangle text-warning"></i>
                                    Muito Lentas:
                                </span>
                                <span class="detail-value text-warning">
                                    {{ formatNumber(statsData.performance.very_slow_requests_week) }}
                                </span>
                            </div>
                        </div>

                        <div
                            class="metric-footer"
                            v-if="!loadingStats"
                        >
                            <div class="performance-indicator">
                                <span class="indicator-label">Saúde do Sistema:</span>
                                <span
                                    class="indicator-value"
                                    :class="getPerformanceHealthClass()"
                                >
                                    {{ getPerformanceHealthLabel() }}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>

import {formatExecutionTime, formatNumber, formatPercentage} from "../../composables/mask";

export default {
    props: {
        loadingStats: {
            type: Boolean,
            required: true
        },
        statsData: {
            type: Object,
            required: true
        }
    },

    data() {
        return {}
    },

    methods: {
        formatPercentage,
        formatExecutionTime,
        formatNumber,

        getPerformanceHealthClass() {
            const avgTime = this.statsData.week ? this.statsData.week.avg_execution_time : 0;
            if (avgTime < 1000) return 'text-success';
            if (avgTime < 3000) return 'text-warning';
            return 'text-danger';
        },

        getPerformanceHealthLabel() {
            const avgTime = this.statsData.week ? this.statsData.week.avg_execution_time : 0;
            if (avgTime < 1000) return 'Excelente';
            if (avgTime < 3000) return 'Bom';
            return 'Atenção';
        },
    },
}
</script>



// WEBPACK FOOTER //
// src/components/IntegrationLog/MainStats.vue